import { useEffect, useRef, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { logout } from '../lib/auth';

export function ProfileDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const nav = useNavigate();

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    if (open) document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  async function handleLogout() {
    await logout();
    window.location.assign('/login');
  }

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex h-9 w-9 items-center justify-center rounded-full border border-border-soft bg-bg-elevated text-sm text-neutral-200 transition hover:border-brand-400"
        title="Profil"
      >
        👤
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-48 overflow-hidden rounded-lg border border-border-soft bg-bg-raised shadow-xl">
          <button
            onClick={() => { setOpen(false); nav({ to: '/settings' }); }}
            className="block w-full px-4 py-2 text-left text-sm text-neutral-200 transition hover:bg-bg-elevated"
          >
            Profil & Ayarlar
          </button>
          <button
            onClick={handleLogout}
            className="block w-full border-t border-border-soft px-4 py-2 text-left text-sm text-neutral-200 transition hover:bg-bg-elevated"
          >
            Çıkış
          </button>
        </div>
      )}
    </div>
  );
}
